module.exports = __webpack_public_path__ + "img/shouye.9781a2d1.png";